module.exports = __webpack_public_path__ + "media/images/covid/icons/hand-cb9325c7781795d7bc3c1abcc42c3655.png";